import { useTranslation } from 'react-i18next';
import { Button, Form } from 'react-bootstrap';
import Pagination from '../Pagination/Pagination';
import styles from '../Shop.module.css';
import List from '../List/List';
import { isDemo } from '../../../../../GlobalContex';
// isDemo

export default function ProductsList({
    products,
    pagination,
    onPageChange,
    onProductAdd,
    onProductSelect,
    onProductDelete,
    onShopSettingsOpen,
} = {}) {
    const { t } = useTranslation();
    return <>
        <Form.Group className="col-12 mb-3">
            <Button className={`w-100`} variant={'primary'} onClick={(e) => {
                    if (isDemo) {
                        window.location.href = 'https://a.electricblaze.com/#/register'
                    } else {
                        onProductAdd(e)
                    }}
                }>
                {t('+ Add product')}
            </Button>
        </Form.Group>
        <Form.Group className="col-12 mb-3">
            {
                products.length
                    ? <List items={products} onItemClick={onProductSelect} onItemDelete={onProductDelete} />
                    : <div className="w-100 text-center fw-bolder p-3" variant="primary">
                        {t('List is Empty')}
                      </div>
            }
        </Form.Group>
        <Pagination
            totalPages={pagination.totalPages}
            currentPage={pagination.currentPage}
            onPageChange={onPageChange}
        />
    </>;
}